import { useState } from 'react';
import {
	GovControlGroup,
	GovDropdown,
	GovIcon,
} from '@gov-design-system-ce/react';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { useDataBoxMessageFormContext } from '@gov-nx/module/data-box';
import { PageCode } from '@gov-nx/module/page';
import { Button } from '@gov-nx/ui/web';

export const AttachmentsDropdown = () => {
	const { openDocumentsModal, openUploadModal } =
		useDataBoxMessageFormContext();
	const [isOpened, setIsOpened] = useState(false);
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tn = getLocalizeCurried(PageCode['datove-schranky']);

	const onAttachmentsClick = () => {
		setIsOpened(false);
		openUploadModal();
	};

	const onDocumentsClick = () => {
		setIsOpened(false);
		openDocumentsModal();
	};

	const onDropdownStateChange = (status: boolean) => {
		setIsOpened(status);
	};

	return (
		<GovControlGroup
			color="primary"
			className="ds-attachments-dropdown sm:w-fit">
			<Button
				color="primary"
				size="s"
				type="base"
				isExpandedMobile
				onClick={onAttachmentsClick}
				className="no-outline-offset"
				aria-label={tn('nova-zprava.nahrat-prilohu-ze-zarizeni')}
				iconStart={
					<GovIcon
						name="attachment"
						type="templates"
					/>
				}>
				<span>{tn('nova-zprava.nahrat-prilohu-ze-zarizeni')}</span>
			</Button>
			<GovDropdown
				position="right"
				color="primary"
				size="s"
				type="base"
				expandedMobile
				className="no-outline-offset"
				aria-label={tn('nova-zprava.wcag.otevrit-nabidku')}
				iconStart={
					<GovIcon
						name="chevron-down"
						type="components"
					/>
				}
				open={isOpened}
				onChange={onDropdownStateChange}>
				<Button
					color="primary"
					type="base"
					size="s"
					isExpanded
					onClick={onAttachmentsClick}
					aria-label={tn('nova-zprava.nahrat-prilohu-ze-zarizeni')}
					className="w-full!"
					iconEnd={
						<GovIcon
							name="upload"
							type="components"
						/>
					}>
					{tn('nova-zprava.nahrat-prilohu-ze-zarizeni')}
				</Button>
				<Button
					color="primary"
					type="base"
					size="s"
					isExpanded
					onClick={onDocumentsClick}
					aria-label={tn('nova-zprava.vybrat-z-mych-souboru')}
					className="w-full!"
					iconEnd={
						<GovIcon
							name="floppy"
							type="templates"
						/>
					}>
					{tn('nova-zprava.vybrat-z-mych-souboru')}
				</Button>
			</GovDropdown>
		</GovControlGroup>
	);
};
